/** @file blendWeight: the outgoing clip's share during a blend, eased over the blend duration. */
import { clamp } from '@zilo/pose3d-std/math/clamp';
import { easeAt } from '@zilo/pose3d-pose/time/easeAt';

/** `1 - easeAt('easeInOut', clamp(elapsed / duration, 0, 1))`; a duration <= 0 gives 0 (no blend). */
export function blendWeight(elapsedSec: number, durationSec: number): number {
  return durationSec <= 0 ? 0 : 1 - easeAt('easeInOut', clamp(elapsedSec / durationSec, 0, 1));
}
